module.exports = __webpack_public_path__ + "img/volunteer.37bae9ed.png";